let activeStepNum = $(".form-tabs-w-steps .tab-pane.active");
let activeStep = $(".form-tabs-w-steps .tab-pane.active");
let backStep = $(".form-tabs-w-steps .back-step");

$(".register-steps-continue").click(function () {
  activeStepNum = $(".form-tabs-w-steps .tab-pane.active");
  activeStep = $(".form-tabs-w-steps .tab-pane.active");
  var atLeastOneIsChecked = $(activeStep).find("input:checked").length > 0;
  if ($(activeStep).find(".related.active").length > 0) {
    atLeastOneIsChecked = $(activeStep).find(".related.active").find("input:checked").length > 0;
  }
  if (atLeastOneIsChecked) {
    if ($(activeStepNum).next(".tab-pane").length > 0) {
      $(".register-steps-continue").removeClass("active");

      let current = $(activeStepNum).addClass("current");
      $(current).hide().removeClass("active");
      $(activeStepNum).next(".tab-pane").show().addClass("show active");

      $(".current").removeClass("current");
      $(backStep).removeClass("d-none");
    }
    activeStepNum = $(".form-tabs-w-steps .tab-pane.active");
    if ($(activeStepNum).next(".tab-pane").length == 0) {
      setTimeout(() => {
        $(".register-steps-continue").attr("type", "submit").addClass("active");
      }, 100);
    }
  } else {
    $(activeStep).find(".error").removeClass("d-none").addClass("d-block");
  }
});

$(backStep).click(function () {
  $(".register-steps-continue").attr("type", "button");
  $(".register-steps-continue").removeClass("active");
  if(goFormDirect){
    $(backStep).addClass("d-none");
    $(".tab-pane:first").show().addClass("show active");
    $('.form-tab').hide().removeClass("active");

  
  }
  else{
  activeStepNum = $(".form-tabs-w-steps .tab-pane.active");
  activeStep = $(".form-tabs-w-steps .tab-pane.active");
  if ($(activeStepNum).prev(".tab-pane").length > 0) {
    let current = $(activeStepNum).addClass("current");

    $(current).hide().removeClass("active");
    $(activeStepNum).prev(".tab-pane").show().addClass("show active");
    $(".current").removeClass("current");
    activeStepNum = $(".form-tabs-w-steps .tab-pane.active");
    if ($(activeStepNum).prev(".tab-pane").length < 1) {
      $(backStep).addClass("d-none");
    }
  }
  }
  
});
  let goFormDirect=false;

$(".form-tabs-w-steps  .styled-check").click(function () {
  if ($(this).hasClass("go-form")) {
    goFormDirect=true;
    let current = $(activeStepNum).addClass("current");
    $(current).hide().removeClass("active");

    $(".selected-path-info").removeClass("d-flex").addClass("d-none");
    
   
    $(".form-tab.tab-pane .main-form").removeClass('d-block').addClass('d-none');
    $(".form-tab.tab-pane .courses-form").removeClass('d-none').addClass('d-block');


    $(".form-tab.tab-pane").show().addClass("show active");

    $(".register-steps-continue").addClass("active").attr("type", "submit").addClass("active");
    $(".back-step").removeClass("d-none").addClass("active");
  } else {
    goFormDirect=false;
    $(".form-tab.tab-pane .main-form").removeClass('d-none').addClass('d-block');
    $(".form-tab.tab-pane .courses-form").removeClass('d-block').addClass('d-none');
   


    $(".selected-path-info").removeClass("d-none").addClass("d-flex");

    $(".register-steps-continue").click();
    $(activeStep).find(".error").removeClass("d-block").addClass("d-none");
    let that = $(this);
    //selected-path
    let selected = $(this).closest(".option");
    $(".selected-education-img").find("img").attr("src", $(selected).find(".icon").attr("src"));

    if ($(this).closest(".option.path").length > 0) {
      let selectedpath = $(this).closest(".option.path");
      $(".selected-education-img").find("img").attr("src", $(selectedpath).find(".icon").attr("src"));
      $(".selected-path").html($(selectedpath).find(".txt").html());
    }
    if ($(this).closest(".option.curriculum").length > 0) {
      selected = $(this).closest(".option.curriculum");
    }
    $(".register-steps-continue").addClass("active1");

    if ($(this).attr("related")) {
      // $(".related").addClass("d-none").removeClass("active");

      $(".related." + $(this).attr("related"))
        .removeClass("d-none")
        .addClass("active")
        .siblings(".related")
        .addClass("d-none")
        .removeClass("active");
      $(activeStep)
        .find(".related." + $(this).attr("related"))
        .find(".error")
        .removeClass("d-block")
        .addClass("d-none");

      $(".selected-education").html($(selected).find(".txt").html());
    } else {
      $(activeStep).find(".error").removeClass("d-block").addClass("d-none");
      let selected = that.closest(".option");
      console.log("amama", $(selected).find(".txt").html());
      $(".selected-class").html($(selected).find(".txt").html());
    }
  }
});
